// @flow
import type { AsyncButtonMessages } from '~/core/types';
import { defineMessages } from 'react-intl';

const messages: AsyncButtonMessages = defineMessages({
    save: {
        id: 'buttons.async.save',
        defaultMessage: 'Save'
    },
    saving: {
        id: 'buttons.async.saving',
        defaultMessage: 'Saving...'
    },
    saved: {
        id: 'buttons.async.saved',
        defaultMessage: 'Saved!'
    },
    error: {
        id: 'buttons.async.error',
        defaultMessage: 'Error'
    }
});

export default messages;



// WEBPACK FOOTER //
// ./src/core/i18n/components/widgets/buttons/async/intl.js